class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.applyButton = this.querySelector('[data-update-coupon]');
    this.message = this.querySelector('[data-coupon-message]');

    if (!this.input || !this.applyButton) return;

    this.applyButton.addEventListener('click', () => this.applyCoupon());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.applyCoupon();
      }
    });

    this.querySelectorAll('[data-remove-coupon]').forEach((button) => {
      button.addEventListener('click', () => this.removeCoupon(button));
    });
  }

  setLoading(isLoading, button = this.applyButton) {
    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);
    this.input.disabled = isLoading;
  }

  setMessage(text, isError = false) {
    if (!this.message) return;
    this.message.textContent = text;
    this.message.classList.toggle('is-error', isError);
  }

  async updateDiscount(discount) {
    const response = await fetch(routes.cart_update_url, {
      ...fetchConfig(),
      body: JSON.stringify({ discount })
    });

    if (!response.ok) throw new Error('Unable to update discount code.');
    return response.json();
  }

  refreshDrawer(cart) {
    if (window.sharedFunctions?.updateSidebarCart) {
      window.sharedFunctions.updateSidebarCart(cart);
    } else {
      document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
    }
  }

  async applyCoupon() {
    const code = this.input.value.trim();

    if (!code) {
      this.setMessage('Please enter a discount code.', true);
      this.input.focus();
      return;
    }

    this.setLoading(true);
    this.setMessage('');

    try {
      const existingCodes = Array.from(this.querySelectorAll('[data-applied-coupon]'))
        .map((coupon) => coupon.dataset.appliedCoupon)
        .filter((existingCode) => existingCode.toLowerCase() !== code.toLowerCase());
      const cart = await this.updateDiscount([...existingCodes, code].join(','));
      const discountCodes = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      const applications = Array.isArray(cart.cart_level_discount_applications)
        ? cart.cart_level_discount_applications
        : [];
      const applied = discountCodes.some((discount) =>
        discount.code?.toLowerCase() === code.toLowerCase() && discount.applicable !== false
      ) || applications.some((discount) =>
        discount.title?.toLowerCase() === code.toLowerCase()
      );

      if (!applied) {
        this.setMessage('This discount code is invalid or not applicable.', true);
        return;
      }

      localStorage.setItem('storedDiscount', code);
      this.refreshDrawer(cart);
    } catch (error) {
      this.setMessage(error.message || 'Unable to apply the discount code.', true);
    } finally {
      this.setLoading(false);
    }
  }

  async removeCoupon(button) {
    this.setLoading(true, button);
    this.setMessage('');

    try {
      const removedCode = button.dataset.couponCode?.toLowerCase();
      const remainingCodes = Array.from(this.querySelectorAll('[data-applied-coupon]'))
        .map((coupon) => coupon.dataset.appliedCoupon)
        .filter((code) => code.toLowerCase() !== removedCode);
      const cart = await this.updateDiscount(remainingCodes.join(','));
      localStorage.removeItem('storedDiscount');
      this.refreshDrawer(cart);
    } catch (error) {
      this.setMessage(error.message || 'Unable to remove the discount code.', true);
    } finally {
      this.setLoading(false, button);
    }
  }
}

customElements.define('coupon-code', CouponCode);

class CartLineRecommendation extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-line-recommendation-add]');
    if (!this.button) return;

    this.button.addEventListener('click', () => this.addToCart());
  }

  async addToCart() {
    const variantId = Number(this.button.dataset.variantId);
    if (!variantId) return;

    this.button.disabled = true;
    this.button.classList.add('is-loading');

    try {
      const response = await fetch(routes.cart_add_url, {
        ...fetchConfig(),
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { __smart_discount_flow_properties: 'random' }
          }]
        })
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.description || 'Unable to add this product.');
      }

      Shopify.getCart((cart) => {
        window.sharedFunctions?.updateSidebarCart(cart);
      });
    } catch (error) {
      if (window.sharedFunctions?.showWarning) {
        window.sharedFunctions.showWarning(error.message);
      } else {
        console.error(error);
      }
      this.button.disabled = false;
      this.button.classList.remove('is-loading');
    }
  }
}

customElements.define('cart-line-recommendation', CartLineRecommendation);
